import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import {
  FaTachometerAlt,
  FaMotorcycle,
  FaBoxOpen,
  FaUsers,
  FaBuilding,
  FaChartLine,
  FaClipboardList,
  FaSignOutAlt,
  FaCog,
  FaPlug,
  FaBook
} from 'react-icons/fa'
import { HiOutlineMenuAlt2 } from 'react-icons/hi'
import { useDispatch } from 'react-redux'
import { logout } from '../../../../store/actions'
import { Button } from '../../../../UI'
import pickOrder from '../../../../assets/pickOrder.svg'
import Container from './styles'

const SideNav = ({ showNav }) => {
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    <Container onClick={showNav}>
      <div className="sideNav--content" onClick={(e) => e.stopPropagation()}>
        <header>
          <Button icon className="toggleMenu--btn" onClick={showNav}>
            <HiOutlineMenuAlt2 />
          </Button>
          <Link to="/">
            <img src={pickOrder} alt="Pick Order" style={{width:100}} />
          </Link>
        </header>
        <nav>
          <div>
            <NavLink to="/company/dashboard" end>
              <FaTachometerAlt />
              Overview
            </NavLink>
            <NavLink to="/company/dashboard/riders">
              <FaMotorcycle />
              Riders
            </NavLink>
            <NavLink to="/company/dashboard/orders">
              <FaBoxOpen />
              Orders
            </NavLink>
            <NavLink to="/company/dashboard/staff">
              <FaUsers />
              Staff
            </NavLink>
            <NavLink to="/company/dashboard/merchants">
              <FaBuilding />
              Merchants
            </NavLink>
            <NavLink to="/company/dashboard/audit-logs">
              <FaClipboardList />
              Activity Logs
            </NavLink>
            <NavLink to="/company/dashboard/statistics">
              <FaChartLine />
              Statistics
            </NavLink>
            <NavLink to="/company/dashboard/webhook-events">
              <FaPlug />
              Webhook Events
            </NavLink>
            <NavLink to="/company/dashboard/webhook-docs">
              <FaBook />
              Webhook Docs
            </NavLink>
            <NavLink to="/company/dashboard/settings">
              <FaCog />
              Settings
            </NavLink>
          </div>
          <div className="nav--footer">
            <Button full onClick={handleLogout}>
              <FaSignOutAlt />
              Log out
            </Button>
          </div>
        </nav>
      </div>
    </Container>
  )
}

export default SideNav
